import { FC, ReactNode } from 'react'
import Foldable from '../Foldable'
import { SectionHeaderFoldableContent } from './styles'

type Props = {
  isOpened?: boolean
  isDragging?: boolean
  children: ReactNode
}

export const SectionHeaderFoldableContainer: FC<Props> = props => {
  const { isOpened, children, isDragging } = props

  if (isDragging) {
    return null
  }

  return (
    <Foldable isOpen={isOpened}>
      <SectionHeaderFoldableContent>{children}</SectionHeaderFoldableContent>
    </Foldable>
  )
}
